import { KeyExtractor } from "../types";

const findIndex = <TItem>({
	data,
	keyExtractor,
	targetKey,
	prevIndex = 0,
}: {
	data: TItem[];
	keyExtractor: KeyExtractor<TItem>;
	targetKey: string;
	prevIndex?: number;
}) => {
	if (prevIndex == null) {
		return data.findIndex((item) => {
			return (
				keyExtractor({
					item,
				}) === targetKey
			);
		});
	} else {
		for (let i = prevIndex, j = prevIndex - 1; i < data.length || j >= 0; i++, j--) {
			if (i < data.length) {
				const item = data[i];
				if (item && keyExtractor({ item }) === targetKey) {
					return i;
				}
			}
			if (j >= 0) {
				const item = data[j];
				if (item && keyExtractor({ item }) === targetKey) {
					return j;
				}
			}
		}
		return -1;
	}
};
export default findIndex;
